import React from "react";
import { useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import {
  FaClock,
  FaDoorOpen,
  FaHourglassHalf,
  FaUtensils,
} from "react-icons/fa";

const TimeExtendModal = ({
  isOpen,
  toggle,
  onExtend,
  onEnd,
  restaurantsDetail,
  currentUserTable,
}) => {
  const { endLoading, extendLoading } = useSelector((state) => state.cart);
  if (!restaurantsDetail) return null;

  const expireTime = currentUserTable?.expireAt?.seconds
    ? new Date(currentUserTable.expireAt.seconds * 1000).toLocaleTimeString(
        [],
        {
          hour: "2-digit",
          minute: "2-digit",
        }
      )
    : "--:--";

  const tableName = currentUserTable?.tableNo || "Unknown";

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        toggle={toggle}
        className="bg-warning-subtle border-bottom-0 text-dark d-flex align-items-center gap-2"
        style={{ fontSize: "1.25rem", fontWeight: 600 }}
      >
        <FaHourglassHalf className="text-warning fs-4" />
        Time Running Out!
      </ModalHeader>

      <ModalBody className="px-4">
        <div className="mb-4">
          <div className="d-flex">
            <div className="mt-1 d-flex align-items-center gap-2 text-secondary mb-1">
              <FaUtensils />
              <small className="ml-1 fw-bold text-uppercase">
                At Restaurant
              </small>
            </div>
            <div className="fs-4 ml-3 fw-semibold text-dark">
              {restaurantsDetail?.restaurantName}
            </div>
          </div>

          <div className="d-flex">
            <div className="mt-1 d-flex align-items-center gap-2 text-secondary mb-1">
              <FaDoorOpen />
              <small className="ml-1 fw-bold text-uppercase">Table</small>
            </div>
            <div className="fs-4 ml-3 fw-semibold text-dark">{tableName}</div>
          </div>
          <div className="d-flex mb-3">
            <div className="mt-1 d-flex align-items-center gap-2 text-secondary mb-1">
              <FaClock />
              <small className="ml-1 fw-bold text-uppercase">Expires At</small>
            </div>
            <div className="fs-4 ml-3 fw-semibold text-dark">{expireTime}</div>
          </div>
        </div>

        <div className="text-secondary fs-6">
          Your reserved table time is about to expire.
          <br />
          Please choose to extend your session or end it.
        </div>
      </ModalBody>

      <ModalFooter className="d-flex flex-column gap-2 px-4 pb-4 border-top-0">
        <Button
          color="success"
          onClick={onExtend}
          disabled={extendLoading?.[tableName]}
          className="w-100 fs-6 py-2"
        >
          ✅ Extend Session
        </Button>
        <Button
          color="danger"
          onClick={onEnd}
          disabled={endLoading?.[tableName]}
          className="w-100 fs-6 py-2"
        >
          ⛔ End Now
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TimeExtendModal;
